(ns frontend.test.number-input.event
  (:require
   [frontend.test.number-input.sub :as sub]
   [re-frame.core :as rf]))

(rf/reg-event-db
 ::init
 (fn [db [_ {:keys [float-value int-value min-decimals max-decimals]}]]
   (assoc db
          ::sub/float-value float-value
          ::sub/integer-value int-value
          ::sub/min-decimals min-decimals
          ::sub/max-decimals max-decimals)))

(rf/reg-event-db
 ::cleanup
 (fn [db _]
   (dissoc db
           ::sub/float-value
           ::sub/integer-value
           ::sub/min-decimals
           ::sub/max-decimals)))

(rf/reg-event-db
 ::on-change-integer
 (fn [db [_ value]]
   (assoc db ::sub/integer-value value)))

(rf/reg-event-db
 ::on-change-float
 (fn [db [_ value]]
   (assoc db ::sub/float-value value)))

(rf/reg-event-db
 ::set-min-decimals
 (fn [db [_ value]]
   (assoc db ::sub/min-decimals value)))


(rf/reg-event-db
 ::set-max-decimals
 (fn [db [_ value]]
   (assoc db ::sub/max-decimals value)))
